module.exports = __webpack_public_path__ + "static/media/Sony SmartWatch 3 White Closed.6e8c021a.png";